/* eslint-disable react/prop-types */
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useProfileQuery } from "../app/features/auth/authApi";
import LoadingUi from "../components/LoadingUi/LoadingUi";
import { isUniEduAdmin, isUniEduStaff } from "../utils/accountType";
import { lastAllowedPath, markDenied } from "../utils/lastDashboardPath";

/** Sends a non-admin back to the last page they could open, with a toast. */
const BackToAllowed = ({ title }) => {
  const location = useLocation();
  const here = `${location.pathname}${location.search}`;
  // During render, before DashBoardLayout's effect, so this page is never
  // remembered as a place to come back to.
  markDenied(here);
  const target = lastAllowedPath(here);

  useEffect(() => {
    // Fixed id: StrictMode's double effect shows one toast, not two.
    toast.error(`You don't have access to ${title}. Only UniEdu admins can open it.`, {
      id: "uniedu-admin-only",
    });
  }, [title]);

  return <Navigate to={target} replace />;
};

/**
 * Partner / Management pages: UniEdu admins only. Plain UniEdu staff and
 * country operators are sent back to where they were (the API refuses them
 * too). Non-staff users fall through — those pages already scope themselves.
 */
const UniEduAdminRoute = ({ title, children }) => {
  const { data: profile, isLoading } = useProfileQuery();
  if (isLoading || !profile) return <LoadingUi />;
  if (isUniEduStaff(profile) && !isUniEduAdmin(profile)) {
    return <BackToAllowed title={title} />;
  }
  return children;
};

export default UniEduAdminRoute;
